import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "page",
  id: "page"
};
const _hoisted_2 = {
  class: "section-md bg-transparent"
};
const _hoisted_3 = {
  class: "container"
};
const _hoisted_4 = {
  class: "row row-25 row-xl-55 justify-content-between flex-md-row-reverse"
};
const _hoisted_5 = {
  class: "col-sm-6 col-lg-4 text-lg-left text-center"
};
const _hoisted_6 = {
  class: "image-block image-block-left"
};
const _hoisted_7 = {
  class: "list list-divided list-divided-sm big"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "line-1"
};
const _hoisted_10 = {
  class: "col-sm-6 col-lg-7"
};
const _hoisted_11 = {
  class: "text-decorated text-decorated-large",
  style: {
    "margin-bottom": "30px"
  }
};
const _hoisted_12 = ["innerHTML"];
import { ref, onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';
import { newsInfo, newsList as newsListHttp } from '@/api/news';

import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/message/style/css';
export default {
  __name: 'case-page',
  setup(__props) {
    const route = useRoute();
    const path = computed(() => {
      return process.env.VUE_APP_BASE_ADDRESS;
    });
    const info = ref(null);
    const newsIdFromUrl = ref('');
    const getData = async (id = '') => {
      const newsId = id || route.query.id;
      if (!newsId) {
        return ElMessage.error('参数错误');
      }
      newsIdFromUrl.value = newsId;
      const data = await newsInfo(newsId);
      if (data) {
        data.thumb = path.value + data.thumb;
        info.value = data;
      }
    };

    // 最新10条新闻
    const lastNewsList = ref([]);
    const getLastNews = async () => {
      const {
        list
      } = await newsListHttp({
        page: 1,
        pageSize: 10
      });
      lastNewsList.value = list;
    };
    onMounted(() => {
      getData();
      getLastNews();
    });
    return (_ctx, _cache) => {
      const _component_Preload = _resolveComponent("Preload");
      const _component_Header = _resolveComponent("Header");
      const _component_Footer = _resolveComponent("Footer");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_Preload), _createElementVNode("div", _hoisted_1, [_createVNode(_component_Header), _createElementVNode("section", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_cache[0] || (_cache[0] = _createElementVNode("h3", {
        class: "text-primary"
      }, "冀华洞见", -1)), _createElementVNode("ul", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lastNewsList.value, item => {
        return _openBlock(), _createElementBlock("li", {
          class: "list-item",
          key: item.id
        }, [_createElementVNode("a", {
          class: _normalizeClass(["link link-arrow", newsIdFromUrl.value == item.id ? 'link-hover' : '']),
          style: {
            "display": "flex",
            "align-items": "center"
          },
          onClick: $event => getData(item.id)
        }, [_createElementVNode("div", _hoisted_9, _toDisplayString(item.title), 1)], 10, _hoisted_8)]);
      }), 128))])])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("h3", _hoisted_11, _toDisplayString(info.value?.title), 1), _createElementVNode("div", {
        class: "big",
        innerHTML: info.value?.content
      }, null, 8, _hoisted_12)])])])]), _createVNode(_component_Footer)])], 64);
    };
  }
};